import { createContext } from 'react';
import { IApplicationContext } from '../types/application';

export const ApplicationContext = createContext<IApplicationContext>({} as IApplicationContext);
